
import BetMenuComponent from "slotworks/components/betbar/bet-menu-component";
import Components from "slotworks/components/components";
import ClockComponent from "slotworks/components/header/clock-component";
import SoundToggleComponent from "slotworks/components/sound/sound-toggle-component";
import { ButtonEvent } from "slotworks/graphics/elements/button-element";
import FlexiButton from "slotworks/graphics/elements/flexi-button";
import Layers from "slotworks/graphics/layers/layers";
import Translations from "slotworks/i18n/translations";
import settingsModel, { RealityMode, Jurisdiction } from "slotworks/model/settings/settings-model";
import deviceInfo from "slotworks/utils/device-info";
import betModel from "slotworks/model/bets/bet-model";
import currency from "slotworks/i18n/currency";
import Timer from "slotworks/utils/timer";
import { HomeCommand } from "slotworks/commands/betbar/home-command";

export default class HeaderComponent {

    private clock: ClockComponent;
    private soundToggle: SoundToggleComponent;
    private mode: string;
    private infoButton: FlexiButton;
    private homeButton: FlexiButton;
    private homeURL: string;
    private homeListenerEnabled: boolean = false;

    private enabled: boolean = true;
    private homeButtonEnabled: boolean = true;

    constructor() {
        Layers.Header.onSceneEnter.add(this.setup);

        this.setup();
    }

    public setEnabled(enable: boolean) {
        this.enabled = enable;

        if (this.infoButton) {
            this.infoButton.setEnabled(this.enabled);
        }
    }

    public setMode(mode: RealityMode) {
        this.mode = mode;

        this.updateMode();
    }

    private setup = () => {
        if (this.clock) {
            this.clock.destroy();
        }

        this.clock = new ClockComponent();

        this.setupSoundToggle();
        this.setupInfoButton();
        this.updateMode();
        this.setupGameName();
        this.setupMaxWinAndRtp();
        this.setupHomeURL();
    }

    private updateMode() {
        const modeLabel = Layers.Header.getFlexiText("mode");
        if (modeLabel && this.mode) {
            modeLabel.setText(Translations.get(this.mode));
        }
        if(modeLabel && settingsModel.socialSweepstakes) {
            modeLabel.setVisible(false);
        }
    }

    protected setupGameName() {
        let name =  document.getElementsByTagName('title')[0].innerText; 
        if(deviceInfo.isDesktop) {
            Layers.Header.onSceneEnter.add((scene: string)=>{
                if(scene == 'freespins') {  
                    let gameName = Layers.Header.getText('game_name');
                    if(gameName) {
                        if(settingsModel.isJurisdiction(Jurisdiction.SE)) {
                            gameName.text = name;
                        }
                        else {
                            gameName.text = "";
                        }
                    }
                }
            })
        }
        else if(settingsModel.isJurisdiction(Jurisdiction.SE)) {
            let nameElements = document.getElementsByClassName('gameName') as any;
            if(nameElements){
                for(let el of nameElements) {
                    el.innerText = name;
                    el.style.display = 'block';
                }            
            }
        }
    } 

    private setupSoundToggle() {
        if (this.soundToggle) {
            this.soundToggle.destroy();
            this.soundToggle = null;
        }

        const soundOnButton = Layers.Header.getFlexiButton("sound_on");
        if (soundOnButton) {
            const soundOffButton = Layers.Header.getFlexiButton("sound_off");

            this.soundToggle = new SoundToggleComponent(soundOnButton, soundOffButton);
        }
    }

    private setupInfoButton() {
        if (this.infoButton) {
            this.infoButton.off(ButtonEvent.POINTER_DOWN, this.showInfo);
        }

        this.infoButton = Layers.Header.getFlexiButton("info");
        if (this.infoButton) {
            this.infoButton.on(ButtonEvent.POINTER_DOWN, this.showInfo);
            this.infoButton.setEnabled(this.enabled);
        }
    }

    private showInfo = () => {
        Components.betMenu.show(BetMenuComponent.RULES);
    }

    private homePressedHandler = () => {
        HomeCommand(this.homeURL).execute();
    }
    private homeListener = (scene: string) => {
        if(this.homeButton) {
            if(scene !== "default") {
                this.homeButtonEnabled = false;
            } else {                
                this.homeButtonEnabled = true;
            }
            this.homeButton.setEnabled(this.homeButtonEnabled);
        }
    }
    private setupHomeURL() {
        if (this.homeButton) {
            this.homeButton.off(ButtonEvent.POINTER_DOWN, this.homePressedHandler);
        }
        this.homeURL = settingsModel.homeURL;
        this.homeButton = Layers.Header.getFlexiButton("home");
        if (this.homeButton) {
            if (this.homeURL === "close" || this.homeURL === "" || this.homeURL === undefined || this.homeURL === null)  {
                this.homeButton.setVisible(false);
            } else {
                this.homeButton.setVisible(true);
                if(!this.homeListenerEnabled) {
                    Layers.Prompts.onSceneEnter.add(this.homeListener);
                }
                this.homeListenerEnabled = true;
                this.homeButton.setEnabled(this.homeButtonEnabled);
            }
            this.homeButton.on(ButtonEvent.POINTER_UP, this.homePressedHandler);
        }
    }

    private setupMaxWinAndRtp() {
        const setText = (scene: string = null) => {
            const maxWinText = Layers.Header.getText("max_win");
            if(maxWinText) {
                if(settingsModel.isJurisdiction(Jurisdiction.DE) && settingsModel.maxWin) {
                    const total = betModel.getTotalBet();
                    const value = total * settingsModel.maxWin / settingsModel.maxWinDelimiter;
                    const maxWin = currency.format(value);
                    const text = Translations.get('max_win_rtp', { max_win: maxWin, max_win_probability: "1:" + settingsModel.maxWinProbability, rtp: settingsModel.rtp});
                    maxWinText.text = text;
                } else {
                    maxWinText.visible = false;
                }
            }
        }
        Layers.Header.onSceneEnter.add(setText);
        if(settingsModel.isJurisdiction(Jurisdiction.DE))
            Components.betBar.onBetUpdated.add(() => { Timer.setTimeout(setText, 10) });
        setText();
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/components/header/header-component.ts